import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/success.svg
 */
const IconSuccess: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M12 24a12 12 0 1112-11.998A12.033 12.033 0 0112 24zm0-22.515a10.517 10.517 0 1010.517 10.517A10.546 10.546 0 0012 1.485z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.13 7.083a1 1 0 01.309 1.38l-4.798 7.568a1.533 1.533 0 01-2.406.236l-3.553-3.733a1 1 0 011.448-1.38l3.142 3.301 4.478-7.063a1 1 0 011.38-.309z"
      fill="currentColor"
    />
  </svg>
);

export default IconSuccess;
